import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { LoginContentWrapper } from 'app/views/login/LoginContentWrapper';
import { observer } from 'mobx-react';
import { LoginBackgroundSafari } from 'app/views/login/components/LoginBackgroundSafari';
import { LoginBackground } from 'app/views/login/components/LoginBackground';

const LoginWrapperBase = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
`;

const LoginWrapperContentContainer = styled.div`
  z-index: 100;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;

  @media (max-width: 1068px) {
    .login-controls {
      align-items: center;
      width: 100%;
    }
    .login-promo {
      display: none;
    }
  }
`;

// There are significant animation performance differences between Chrome and Safari/Firefox. Browsers other than
// Safari and Firefox are assumed to have the same performance characteristics as Chrome as they are all based on Chromium.
let isSafariBrowser = false;
let isFirefoxBrowser = false;
if (typeof navigator !== 'undefined') {
  const ua = navigator.userAgent;
  // lots of browsers include "safari" in their UA name for historical reasons, we exclude those then look for "safari"
  isSafariBrowser = /^((?!chrome|chromium|crios|fxios).)*safari/i.test(ua);
  // Firefox is pretty easy to detect in comparison
  isFirefoxBrowser = /Firefox/.test(ua);
}

/**
 * Wraps the login experience page, establishing the background and content areas for login
 */
export const LoginWrapper = observer(({ children }) => {
  const [pos, setPos] = useState([0, 0]);
  // track user's mouse pointer
  const onMouseMove = useCallback((event) => {
    setPos([event.clientX, event.clientY]);
  }, []);

  return (
    <LoginWrapperBase onMouseMove={onMouseMove}>
      {isSafariBrowser || isFirefoxBrowser ? <LoginBackgroundSafari pos={pos} /> : <LoginBackground pos={pos} />}
      <LoginWrapperContentContainer>
        <LoginContentWrapper>{children}</LoginContentWrapper>
      </LoginWrapperContentContainer>
    </LoginWrapperBase>
  );
});
